import { setShowValuationModal } from '../State/showValuationModal';
import fetchValuation from '../Services/fetchValuation';

export default () => async (dispatch) => {
  
  dispatch(setShowValuationModal(false));
  await dispatch(fetchValuation());

}